/**
 * Booking Host Route Definitions — Issue #2838
 *
 * `booking.ripia.jp/<slug>` 配下の子ルートパス定義を SSOT 化する。
 *
 * `AppRouter.tsx` の booking host 分岐と `AppRouter.host.test.tsx` の
 * Scenario Matrix が **この同じ配列を参照する** ことで drift を防ぐ。新しい
 * 子ルートを追加する場合は以下の手順に従うこと:
 *
 *   1. この配列に path を追加する
 *   2. `AppRouter.tsx` の `BOOKING_NESTED_ROUTE_ELEMENTS` に対応する
 *      `React.ReactNode` を追加する (TypeScript が Record の完全性を強制する)
 *   3. `AppRouter.host.test.tsx` にシナリオを追加する (iteration で自動網羅可)
 *
 * @see Issue #2838
 */

/**
 * booking.ripia.jp/<slug>/... の子ルートパス。
 *
 * `index` は空文字 `''` で表現する (React Router の `<Route index>` に対応)。
 * これにより `/:slug` (ランディング) と `/:slug/staff` 等を同じ配列で管理できる。
 */
export const BOOKING_NESTED_ROUTE_PATHS = [
  '', // index route (BookingSiteHome)
  'staff',
  'menu',
  'datetime',
  'confirm',
  'complete',
] as const;

export type BookingNestedRoutePath =
  (typeof BOOKING_NESTED_ROUTE_PATHS)[number];
